import { Injectable } from '@angular/core';
import { IMyOptions } from '../interfaces/public-api';
import { Year, DefaultView, ShowType } from '../enums/public-api';

@Injectable()
export class DefaultConfigService {
    private defaultConfig: IMyOptions = {
        dateRange: false,
        dayLabels: {
            su: 'Sun',
            mo: 'Mon',
            tu: 'Tue',
            we: 'Wed',
            th: 'Thu',
            fr: 'Fri',
            sa: 'Sat'
        },
        monthLabels: {
            1: 'Jan',
            2: 'Feb',
            3: 'Mar',
            4: 'Apr',
            5: 'May',
            6: 'Jun',
            7: 'Jul',
            8: 'Aug',
            9: 'Sep',
            10: 'Oct',
            11: 'Nov',
            12: 'Dec'
        },
        dateFormat: 'yyyy-MM-dd',
        returnFormat: 'yyyy-MM-dd',
        defaultView: DefaultView.Date,
        showType: ShowType.all,
        firstDayOfWeek: 'mo',
        satHighlight: false,
        sunHighlight: false,
        highlightDates: [],
        markCurrentDay: true,
        markCurrentMonth: true,
        markCurrentYear: true,
        monthSelector: true,
        yearSelector: true,
        disableHeaderButtons: true,
        showWeekNumbers: false,
        selectorHeight: '295px',
        selectorWidth: '287px',
        disableUntil: { year: 0, month: 0, day: 0 ,hour:0,minute:0,second:0},
        disableSince: { year: 0, month: 0, day: 0 ,hour:0,minute:0,second:0},
        disableDates: [],
        disableDateRanges: [],
        disableWeekends: false,
        disableWeekdays: [],
        enableDates: [],
        markDates: [],
        markWeekends: { marked: false, color: '' },
        closeSelectorOnDateSelect: true,
        closeSelectorOnDocumentClick: true,
        minYear: Year.min,
        maxYear: Year.max,
        focusInputOnDateSelect: true,
        moveFocusByArrowKeys: true,
        dateRangeDatesDelimiter: ' - ',
        inputFieldValidation: true,
        stylesData: { selector: '', styles: '' },
        ariaLabelPrevMonth: 'Previous Month',
        ariaLabelNextMonth: 'Next Month',
        shortcuts: [],
        weekText: 'Week'
    };

    public getDefaultConfig() {
        return this.defaultConfig;
    }
}
